import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'
// import api from '@/_helpers/APIClient'

export const Home = {
  namespaced: true,
  state: {
    menudata: [],
    dataAll: [],
    data1: [],
    data2: [],
    popups: [],
    current: null,
    lastUpdated: 0
  },
  getters: {
    allList: state => state.dataAll,
    menuList: state => state.menudata,
    newsList1: state => state.data1,
    newsList2: state => state.data2,
    detailNews: state => state.current,
    popups: state => state.popups,
    lastUpdated: state => state.lastUpdated,
    isBadge: (state) => {
      const localDate = localStorage.getItem('news_update_at')
      if (state.lastUpdated !== '') localStorage.setItem('news_update_at', state.lastUpdated)
      if (localDate) {
        return (localDate === `${state.lastUpdated}`) ? '0' : '1'
      } else {
        return '1'
      }
    }
  },
  mutations: {
    UPDATE_ALLLIST (state, payload) {
      state.dataAll = payload
    },
    UPDATE_MENU (state, payload) {
      state.menudata = payload
    },
    UPDATE_NEWS1 (state, payload) {
      state.data1 = payload
    },
    UPDATE_NEWS2 (state, payload) {
      state.data2 = payload
    },
    UPDATE_CURRENT_NEWS (state, payload) {
      state.current = payload
    },
    UPDATE_POPUP (state, payload) {
      state.popups = payload
    },
    UPDATE_LAST_UPDATE (state, payload) {
      state.lastUpdated = payload
    }
  },
  actions: {
    /**
     * ポップアップリストから外す
     * @param {object} commit
     * @param {*} payload
     */
    action_DeletePopup ({ commit }, id) {
      const popups = this.state.Home.popups.filter(data => data.id !== id)
      commit('UPDATE_POPUP', popups)
    },
    /**
     * 詳細Newsデータの選択
     * @param {Object} commit
     * @param {String} id
     */
    action_SelectDetailNews ({ commit }, id) {
      console.log(this.state)
      console.log(this.state.Home)
      const array = this.state.Home.dataAll.filter(data => data.id === id)
      console.log(array)
      console.log(array.length)
      if (array.length !== 1 || !array) throw new Error('指定されたNewsが見つかりませんでした')
      if (window.localStorage) {
        window.localStorage.setItem('home-detail', JSON.stringify(array[0]))
      }
      commit('UPDATE_CURRENT_NEWS', array[0])
    },
    /**
     * Home画面のinfoデータを取得
     * @param {Object} commit
     * @param {String} payload.token
     * @param {String} payload.accTime
     */
    async action_FetchInfo ({ commit }, payload) {
      const token = payload.token
      const accTime = payload.accTime
      const userId = payload.userId
      let res = null
      if (token !== '' && token !== undefined) {
        res = await APIClient.getInfoList(token, accTime, userId)
      } else {
        // res = await api.getInfoList()
        const error = { code: ErrorCode.CODE_ERROR_TOKEN, message: ErrorMessage.MSG_ERROR_TOKEN }
        throw error
      }
      console.log(res)

      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        const array1 = res.data['data']['info_data']['infos_1']
        const array2 = res.data['data']['info_data']['infos_2']
        const menuarray = res.data['data']['info_data']['pickup_menus']
        commit('UPDATE_MENU', menuarray)
        commit('UPDATE_NEWS1', array1)
        commit('UPDATE_NEWS2', array2)
        commit('UPDATE_LAST_UPDATE', res.data['data']['last_update_at'])
        // popupデータがあるか調べる
        const popups = []
        const dataAll = []
        array1.forEach(data => {
          dataAll.push(data)
          if (data.is_popup === '1') {
            const key = `news_${data.id}`
            const storageData = localStorage.getItem(key)
            if (storageData) {
              if (storageData === '0') {
                popups.push(data)
              }
            } else {
              localStorage.setItem(key, '0')
              popups.push(data)
            }
          }
        })
        array2.forEach(data => {
          dataAll.push(data)
          if (data.is_popup === '1') {
            const key = `news_${data.id}`
            const storageData = localStorage.getItem(key)
            if (storageData) {
              if (storageData === '0') {
                popups.push(data)
              }
            } else {
              localStorage.setItem(key, '0')
              popups.push(data)
            }
          }
        })
        commit('UPDATE_ALLLIST', dataAll)
        commit('UPDATE_POPUP', popups)
      } else {
        const error = { code: res.data.data.code, message: res.data.data.message }
        throw error
      }
    }
  }
}
